export const environment = {
  production: true,
  baseUrl: 'https://wizard.firstmac.com.au/',
  blurbBaseUrl: 'https://assets.firstmac.com.au/wizards',
  smsfEnabled: true,
  auth: {
    internal: {
      redirectUrl: 'https://wizard.firstmac.com.au/internal/',
      discovery: 'https://login.firstmac.com.au/auth/ls/intcrumbs_aad/.well-known/openid-configuration',
      acrValues: 'idp:aadfed tenant:internal_crumbs',
      issuer: 'https://firstmac',
      appID: 'internal',
      scope: 'openid profile roles sitetype crumbsidentity',
      oidc: true,
      source: 'internal', // this is the channel to be saved in the vx-application,
    },
    brokerHome: {
      redirectUrl: 'https://wizard.firstmac.com.au/broker-home/',
      discovery: 'https://login.firstmac.com.au/auth/ls/third-party/.well-known/openid-configuration',
      issuer: 'https://firstmac',
      appID: 'third-party',
      scope: 'openid profile roles sitetype crumbsidentity',
      oidc: true,
      source: 'third-party', // this is the channel to be saved in the vx-application
    },
    brokerCar: {
      redirectUrl: 'https://wizard.firstmac.com.au/broker-car/',
      discovery: 'https://login.firstmac.com.au/auth/ls/3pab/.well-known/openid-configuration',
      issuer: 'https://firstmac',
      appID: 'absbroker',
      scope: 'openid profile roles sitetype crumbsidentity',
      oidc: true,
      source: 'third-party', // this is the channel to be saved in the vx-application
    },
    active: {
      redirectUrl: '',
      discovery: '',
      issuer: '',
      appID: '',
      scope: '',
      oidc: true,
      source: '',
      channel: '',
      shop: '',
      creationSource: '',
    }
  },
  api: {
    // originators: 'https://www.firstmac.com.au/carloans/wizard/me',
    abn: 'https://api.firstmac.com.au/client/ext/orgid/search',
    equipment: 'https://www.firstmac.com.au/carloans/wizard',
    types: 'https://api.firstmac.com.au/types',
    aux: 'https://api.firstmac.com.au/forms/aux',
    submission: 'https://api.firstmac.com.au/submission',
    product: 'https://api.firstmac.com.au/vx-product',
    client: 'https://api.firstmac.com.au/client',
    collateral: 'https://api.firstmac.com.au/collateral',
    scorecard: 'https://api.firstmac.com.au/scorecard',
    workbook: 'https://api.firstmac.com.au/workbook',
    communications: 'https://api.firstmac.com.au/communications',
    sales: 'https://api.firstmac.com.au/sales',
    lcaDomain: 'https://www.loans.com.au',
    vx: 'https://api.firstmac.com.au/vx',
    files: 'https://api.firstmac.com.au/files',
    vxCore: 'https://api.firstmac.com.au/vx-core'
  }
};
